//Global Imports
import React from "react";
import { useNavigate } from "react-router-dom";
import clsx from "clsx";
import moment from "moment";
//End Global Imports

//Local Imports
import Footer from "../../../components/layout/Footer";
import { RightArrowFilledIcon } from "../../../assets/Icons";
import StepOne from "./StepOne";
import { SuccessfullBanner } from "./SuccessfullBanner";
import OtpPhase from "../OtpPhase";
import { getRequestTime, registerUserData, sendOtp, validateOtp } from "../../../services/auth";
import TermsModal from "./StepOne/TermsModal";
import MasterVendorOtpBoxModal from "./StepOne/MasterVendorOtpBoxModal";
import { toast, ToastContainer } from "react-toastify";
import { hop_benefits } from "../../../constants";
import Button from "../../../components/ui/Button";
import AuthBgLayout from "../../../components/layout/AuthBgLayout";
import StepOneNew from "./StepOne/StepOneNew";
import OtpPhaseNew from "../OtpPhase/OtpPhaseNew";
//End Local Imports

const SignUpNew: React.FC = () => {
  const navigate = useNavigate();
  const [otpValue, saveOtpValue] = React.useState<string>("");
  const [otpError, setOTPError] = React.useState<boolean>(false);
  const [isActiveStep, setActiveStep] = React.useState<number>(1);
  const [countryCode, saveCountryCode] = React.useState<string>("+91");
  const [isOTPVerified, setOTPVerified] = React.useState<boolean>(false);
  const [isRegisteredSuccessful, setIsRegisteredSuccessful] = React.useState<boolean>(false);
  const [isTermsModalOpen, setIsTermsModalOpen] = React.useState<boolean>(false);
  const [masterVendorEmail, setMasterVendorEmail] = React.useState<string | undefined>(undefined);
  const [isMasterVendorOtpBox, setIsMasterVendorOtpBox] = React.useState<boolean>(false);
  const [userData, saveUserData] = React.useState({
    mobileNumber: "",
    email: "",
    password: "",
    confirmpassword: "",
    vendorCode: "",
  });
  const [verifyOtpError, setVerifyOtpError] = React.useState<string>("");
  const [date, saveDate] = React.useState(Date.now() + 120000);
  const [dateKey, saveDateKey] = React.useState(0);
  const [otpLoader, setOtpLoader] = React.useState(false);

  //TODO@Chintan: Need to modified Sign-Up flow as per old flow email and mobile both have to be verified


  const verifyOTP = () => {
    setOtpLoader(true);
    getRequestTime().then((response: any) => {
      const reqTime = response.data.currentTime;

      validateOtp({
        email_phone: countryCode + userData.mobileNumber,
        otp: otpValue,
        otpType: "mobile",
      })
        .then((response: any) => {
          const responseTime = response?.data?.timeStamp;
          const timeStampDiff = moment(responseTime, "hh:mm:ss").diff(
            moment(reqTime, "hh:mm:ss"),
            "seconds",
          );
          if (response?.data?.success && timeStampDiff <= 10) {
            getRequestTime().then((response: any) => {
              const reqTime = response.data.currentTime;

              setOTPError(false);
              setOTPVerified(true);
              registerUserData({
                email: userData.email,
                password: userData.password,
                is_email_verified: true,
                is_phone_verified: true,
                is_master_verified: masterVendorEmail ? true : false,
                phoneNumber: countryCode + userData.mobileNumber,
                partnerType: "moneyhop",
                vendor_code: userData.vendorCode,
              })
                .then((res: any) => {
                  const responseTime = res?.data?.timeStamp;
                  const timeStampDiff = moment(responseTime, "hh:mm:ss").diff(
                    moment(reqTime, "hh:mm:ss"),
                    "seconds",
                  );
                  if (res?.data?.isOtpSent && timeStampDiff <= 10) {
                    setIsMasterVendorOtpBox(true);
                    setMasterVendorEmail(res?.data?.masterVendorEmail);
                  } else if (res?.data?.success) {
                    setIsRegisteredSuccessful(true);
                    setTimeout(() => {
                      navigate("/auth/sign-in-new");
                    }, 700);
                  } else {
                    setIsRegisteredSuccessful(false);
                    setVerifyOtpError(res?.response?.data?.error?.type);
                  }
                })
                .catch((error) => {
                  setOTPVerified(false);
                  setVerifyOtpError(error?.response?.data?.error?.type);
                  setTimeout(() => {
                    setVerifyOtpError("");
                    setActiveStep(1);
                  }, 3000);
                  console.error(error);
                });
            });
          } else if (response?.data?.is_invalid) {
            setOTPError(true);
            setOTPVerified(false);
            setVerifyOtpError(response?.data?.message);
          } else {
            setOTPError(true);
            setOTPVerified(false);
            setVerifyOtpError(response?.response?.data?.error?.type);
          }
        })
        .catch((error) => {
          console.error(error);
          toast.error(error?.response?.data?.error?.type);
        })
        .finally(() => setOtpLoader(false));
    });
  };
  //jhsdj
  const resendOTP = () => {
    setOtpLoader(true);
    sendOtp({
      body: {
        phoneNumber: countryCode + userData.mobileNumber,
        otpType: "mobile",
      },
      apiType: "resend",
    })
      .then(() => {
        saveDate(Date.now() + 120000);
        saveDateKey(dateKey + 1);
      })
      .catch((error) => {
        console.error(error);
      })
      .finally(() => setOtpLoader(false));
  };

  return isRegisteredSuccessful ? (
    <AuthBgLayout>
      <SuccessfullBanner title="Your OTP verification has successful — let’s get started." btnText="Get Started" handler={() => {
        navigate("/auth/sign-in-new");
      }} />
    </AuthBgLayout>
  ) : (
    <>
      <ToastContainer position="top-center" />
          {/* <div className="flex h-[52px] bg-[#0F5BF1] w-full items-center py-5 pl-6">
          <svg width="190" height="32" viewBox="0 0 190 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M164.857 22.618C163.631 22.618 162.493 22.4 161.444 21.9651C160.393 21.5303 159.485 20.9334 158.719 20.1766C157.953 19.4186 157.352 18.5266 156.915 17.4981C156.479 16.4708 156.26 15.372 156.26 14.2016C156.26 13.0312 156.478 11.9323 156.915 10.905C157.353 9.87766 157.953 8.98449 158.719 8.22657C159.485 7.46866 160.393 6.87284 161.444 6.43799C162.493 6.00314 163.631 5.78516 164.857 5.78516C166.084 5.78516 167.221 6.00314 168.271 6.43799C169.32 6.87284 170.228 7.46978 170.995 8.22657C171.761 8.98449 172.363 9.87766 172.799 10.905C173.237 11.9323 173.455 13.0312 173.455 14.2016C173.455 15.372 173.237 16.4708 172.799 17.4981C172.363 18.5266 171.761 19.4186 170.995 20.1766C170.229 20.9345 169.32 21.5303 168.271 21.9651C167.221 22.4 166.084 22.618 164.857 22.618ZM164.857 19.7372C165.623 19.7372 166.339 19.602 167.006 19.3326C167.673 19.062 168.255 18.6876 168.753 18.2069C169.251 17.7273 169.641 17.146 169.926 16.463C170.209 15.78 170.35 15.0265 170.35 14.2016C170.35 13.3766 170.209 12.6231 169.926 11.9401C169.642 11.2571 169.251 10.6758 168.753 10.1963C168.255 9.71669 167.673 9.34109 167.006 9.07056C166.339 8.80004 165.622 8.6659 164.857 8.6659C164.092 8.6659 163.374 8.80116 162.709 9.07056C162.043 9.33997 161.46 9.71557 160.962 10.1963C160.464 10.6769 160.072 11.2582 159.789 11.9401C159.506 12.6231 159.364 13.3766 159.364 14.2016C159.364 15.0265 159.506 15.7811 159.789 16.463C160.072 17.146 160.463 17.7273 160.962 18.2069C161.46 18.6876 162.042 19.062 162.709 19.3326C163.375 19.6031 164.091 19.7372 164.857 19.7372Z" fill="white" />
            <path d="M143.962 6.14399H140.859V22.258H143.962V15.4614H150.881V22.258H153.985V6.14399H150.881V12.5807H143.962V6.14399Z" fill="white" />
            <path d="M71.6267 11.2303H68.7998V22.258H71.8106V16.9012C71.8106 16.4362 71.8642 16.0002 71.9715 15.5955C72.0789 15.1909 72.2319 14.8421 72.4317 14.5492C72.6303 14.2563 72.8758 14.0238 73.1669 13.8517C73.4581 13.6784 73.7949 13.5923 74.1785 13.5923C75.4961 13.5923 76.1549 14.3424 76.1549 15.8426V22.2569H79.1656V16.9001C79.1656 16.4351 79.2227 15.9991 79.338 15.5944C79.4533 15.1898 79.6143 14.841 79.821 14.5481C80.0288 14.2552 80.2845 14.0227 80.5916 13.8506C80.8976 13.6773 81.2504 13.5912 81.6489 13.5912C82.9048 13.5912 83.5339 14.3413 83.5339 15.8415V22.2558H86.5446V15.3015C86.5446 14.6577 86.4601 14.0607 86.2923 13.513C86.1233 12.9652 85.8744 12.4968 85.5456 12.1067C85.2157 11.7177 84.7989 11.4136 84.2931 11.1956C83.7874 10.9788 83.1902 10.8692 82.5006 10.8692C81.5804 10.8692 80.7994 11.0693 80.1555 11.4661C79.5116 11.863 79.0138 12.3403 78.661 12.8948C78.4155 12.3258 78.0022 11.8451 77.4199 11.455C76.8365 11.0648 76.1172 10.8692 75.2586 10.8692C74.5222 10.8692 73.852 11.0347 73.2469 11.3644C72.6417 11.6953 72.1634 12.1302 71.8106 12.6701H71.6267V11.2303Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M96.762 11.3096C96.0336 11.0168 95.2332 10.8703 94.3598 10.8703C93.4864 10.8703 92.6849 11.0168 91.9576 11.3096C91.2292 11.6025 90.6012 12.0072 90.0726 12.5248C89.544 13.0423 89.1307 13.6616 88.8315 14.3815C88.5324 15.1014 88.3828 15.8895 88.3828 16.7447C88.3828 17.5999 88.5324 18.388 88.8315 19.1079C89.1307 19.8278 89.544 20.4471 90.0726 20.9647C90.6012 21.4822 91.2292 21.8869 91.9576 22.1798C92.686 22.4727 93.4864 22.6191 94.3598 22.6191C95.2332 22.6191 96.0336 22.4727 96.762 22.1798C97.4904 21.8869 98.1184 21.4822 98.647 20.9647C99.1757 20.4471 99.589 19.8278 99.8881 19.1079C100.187 18.388 100.337 17.5999 100.337 16.7447C100.337 15.8895 100.187 15.1014 99.8881 14.3815C99.589 13.6616 99.1757 13.0423 98.647 12.5248C98.1184 12.0072 97.4893 11.6025 96.762 11.3096ZM95.4741 19.6813C95.1145 19.8233 94.7423 19.8949 94.3598 19.8949C93.9602 19.8949 93.5857 19.8244 93.2329 19.6813C92.8813 19.5383 92.5673 19.3326 92.291 19.062C92.0147 18.7915 91.7966 18.4617 91.6356 18.0716C91.4758 17.6815 91.3947 17.2388 91.3947 16.7436C91.3947 16.2484 91.4747 15.8057 91.6356 15.4156C91.7966 15.0254 92.0158 14.6957 92.291 14.4251C92.5662 14.1546 92.8801 13.9489 93.2329 13.8058C93.5857 13.6639 93.9773 13.5923 94.3598 13.5923C94.7423 13.5923 95.1145 13.6639 95.4741 13.8058C95.8349 13.9489 96.1523 14.1546 96.4286 14.4251C96.7049 14.6957 96.923 15.0254 97.084 15.4156C97.2438 15.8057 97.3249 16.2484 97.3249 16.7436C97.3249 17.2388 97.245 17.6815 97.084 18.0716C96.923 18.4617 96.7049 18.7915 96.4286 19.062C96.1523 19.3326 95.8338 19.5394 95.4741 19.6813Z" fill="white" />
            <path d="M104.864 12.6712H105.048C105.4 12.1167 105.875 11.6774 106.472 11.3544C107.07 11.0324 107.752 10.8703 108.518 10.8703C109.223 10.8703 109.844 10.9832 110.381 11.2079C110.917 11.4326 111.358 11.7523 111.703 12.1648C112.048 12.5773 112.308 13.0725 112.484 13.6504C112.66 14.2284 112.749 14.87 112.749 15.5743V22.258H109.738V15.9343C109.738 15.1394 109.557 14.5503 109.198 14.168C108.838 13.7857 108.313 13.5946 107.623 13.5946C107.21 13.5946 106.846 13.6806 106.532 13.8539C106.218 14.0261 105.95 14.2586 105.728 14.5514C105.505 14.8443 105.338 15.1898 105.222 15.5866C105.107 15.9846 105.05 16.4082 105.05 16.8587V22.2603H102.039V11.2303H104.866V12.6701L104.864 12.6712Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M123.793 21.7863C124.673 21.2307 125.375 20.503 125.896 19.6031L125.893 19.602L123.388 18.3868C123.128 18.8519 122.772 19.2387 122.32 19.5461C121.868 19.8535 121.297 20.0078 120.607 20.0078C120.254 20.0078 119.91 19.9586 119.573 19.8613C119.236 19.7641 118.925 19.6064 118.642 19.3885C118.359 19.1705 118.122 18.9011 117.93 18.578C117.738 18.2549 117.612 17.8693 117.551 17.4188H126.033C126.033 17.3293 126.041 17.2466 126.056 17.1717C126.056 17.0968 126.063 17.0152 126.078 16.9247V16.6542C126.078 15.8303 125.955 15.0646 125.711 14.3592C125.465 13.6538 125.106 13.0423 124.631 12.5248C124.156 12.0072 123.565 11.6025 122.861 11.3096C122.155 11.0168 121.352 10.8703 120.447 10.8703C119.589 10.8703 118.803 11.0279 118.091 11.3432C117.377 11.6584 116.761 12.0832 116.24 12.6153C115.719 13.1485 115.313 13.7712 115.022 14.4833C114.731 15.1953 114.586 15.9499 114.586 16.7447C114.586 17.5999 114.735 18.3846 115.034 19.0967C115.332 19.8099 115.75 20.4281 116.287 20.9535C116.823 21.4789 117.455 21.8869 118.183 22.1798C118.912 22.4727 119.704 22.6191 120.563 22.6191C121.834 22.6191 122.911 22.3407 123.793 21.7863ZM122.965 14.6744C123.079 14.9148 123.145 15.1327 123.16 15.3272H117.712C117.91 14.6822 118.255 14.1792 118.746 13.8192C119.236 13.4593 119.803 13.2793 120.447 13.2793C120.907 13.2793 121.301 13.3464 121.631 13.4817C121.961 13.6169 122.236 13.7891 122.459 13.9992C122.681 14.2094 122.849 14.4341 122.965 14.6744Z" fill="white" />
            <path d="M126.585 11.2303L131.32 21.7175L128.815 27.1185H132.056L139.112 11.2303H135.757L133.021 17.914H132.86L130.01 11.2303H126.585Z" fill="white" />
            <path fill-rule="evenodd" clip-rule="evenodd" d="M175.958 6.14399V22.2558H179.062V16.3367H181.75C182.533 16.3367 183.264 16.2126 183.946 15.9655C184.628 15.7185 185.221 15.3697 185.727 14.9192C186.233 14.4698 186.631 13.9333 186.923 13.3106C187.214 12.688 187.36 11.9792 187.36 11.2292C187.36 10.4791 187.214 9.7927 186.923 9.17005C186.631 8.54852 186.233 8.01194 185.727 7.56144C185.221 7.11094 184.628 6.76217 183.946 6.51512C183.263 6.26807 182.533 6.14399 181.75 6.14399H175.958ZM183.637 12.783C183.222 13.2335 182.609 13.4582 181.797 13.4582H179.063V9.02473H181.798C182.212 9.02473 182.571 9.08509 182.878 9.2047C183.184 9.32543 183.441 9.48641 183.648 9.68874C183.856 9.89107 184.009 10.1269 184.108 10.3975C184.207 10.668 184.258 10.9452 184.258 11.2303C184.258 11.8149 184.05 12.3325 183.637 12.783Z" fill="white" />
            <path d="M56.964 3.04785C59.0823 3.04785 60.7995 4.71439 60.7995 6.77017V24.8009C60.7995 26.8567 59.0823 28.5232 56.964 28.5232C54.8457 28.5232 53.1285 26.8567 53.1285 24.8009V6.77017C53.1285 4.71439 54.8457 3.04785 56.964 3.04785Z" fill="white" />
            <path d="M26.2047 9.40227C27.7026 7.94861 27.7026 5.59177 26.2047 4.13811C24.7069 2.68445 22.2784 2.68445 20.7805 4.13811L2.64293 21.7403C1.14506 23.194 1.14506 25.5508 2.64293 27.0045C4.1408 28.4582 6.56932 28.4582 8.06719 27.0045L26.2047 9.40227Z" fill="white" />
            <path d="M41.7548 3.47753C40.7321 3.44544 39.6986 3.80821 38.918 4.56581L20.7804 22.168C19.2826 23.6217 19.2825 25.9785 20.7804 27.4322C22.2783 28.8859 24.7068 28.8859 26.2047 27.4322L37.8732 16.1081V25.2303C37.8732 27.2861 39.5904 28.9526 41.7087 28.9526C43.827 28.9526 45.5442 27.2861 45.5442 25.2303V7.19958C45.5442 5.15873 43.8519 3.50149 41.7548 3.47753Z" fill="white" />
          </svg>
        </div> */}
      <AuthBgLayout>
        <div className="flex flex-row items-center w-full justify-between">
          <p className="xl:text-[24px] lg:text-[20px] font-semibold text-[#000] font-roboto">Sign up</p>
          {/* <div className="flex flex-col items-start gap-1">
            <p className="text-[#C9C9C9] text-base text-right font-roboto font-bold">{isActiveStep === 1 ? "Step 1:" : "Step 2:"}</p>
            <p className="text-[#000] text-base text-right font-roboto font-normal">{isActiveStep === 1 ? "Basic Details" : "Mobile & email verification"}</p>
          </div> */}
        </div>

        {isActiveStep === 1 && (
          <StepOneNew
            setActiveStep={setActiveStep}
            saveUserData={saveUserData}
            countryCode={countryCode}
            userData={userData}
            saveCountryCode={saveCountryCode}
            setIsTermsModalOpen={setIsTermsModalOpen}
          />
        )}
        {isActiveStep === 2 && (
          <OtpPhaseNew
            otpValue={otpValue}
            setOtpValue={saveOtpValue}
            otpError={otpError}
            verifyOTP={verifyOTP}
            otpLoader={otpLoader}
            isOTPVerified={isOTPVerified}
            verifyOtpError={verifyOtpError}
            resendOTP={resendOTP}
            dateKey={dateKey}
            isLoading={otpLoader}
            date={date}
            buttonText="Verify"
            rootClass=""
          />
        )}

        {isActiveStep === 3 && (
          <SuccessfullBanner title="Your OTP verification has successful — let’s get started." btnText="Continue to log in" handler={() => {
            navigate("/auth/sign-in-new");
          }} />
          )}

       {isActiveStep === 3 ? null : <p
          className="text-[#0F5BF1] font-inter text-lg lg:text-base font-normal mt-3 cursor-pointer text-center"
          onClick={() => {
            navigate("/auth/sign-in-new")
          }}
        >
          Go Back to Login
        </p>}

        {isTermsModalOpen && (
          <TermsModal isTermsModalOpen={isTermsModalOpen} setIsTermsModalOpen={setIsTermsModalOpen} />
        )}
        {isMasterVendorOtpBox && (
          <MasterVendorOtpBoxModal
            isMasterVendorOtpBox={isMasterVendorOtpBox}
            setIsMasterVendorOtpBox={setIsMasterVendorOtpBox}
            masterVendorEmail={masterVendorEmail}
            userData={userData}
            setIsRegisteredSuccessful={setIsRegisteredSuccessful}
          />
        )}
      </AuthBgLayout>
    </>
  );
};

export default SignUpNew;
